import { Button, Col, Form, Input, Modal, Row, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { locales, mailTemplateAPI, PRODUCTION_URL, TINY_MCE_API_KEY } from "../../api/api";
import {
  getRejectedChangesNotificationMailTemplate,
  REJECTED_CHANGES_NOTIFICATION_MAIL_TEMPLATE,
  setMailTemplate,
  setMailTemplateSubject
} from "../../store/mailTemplatesSlice";
import Loader from "../../components/Loader/Loader";
import { tabsChange, updateTemplate } from "../../helpers/mailTemplatesHelpers";
import { Editor } from "@tinymce/tinymce-react";

const { TabPane } = Tabs;
export const RejectedChangesNotificationMailTemplate = () => {
  const dispatch = useDispatch();
  const { setTitle } = useOutletContext();
  const { rejectedChangesNotificationMailTemplate } = useSelector((state) => state.mailTemplates);
  const { isLoading } = useSelector((state) => state.auth);
  const { t } = useTranslation([
    "FA5-ExporterIncomingRequestMailTemplate",
    "FA52-B-RejectedChangesNotificationMailTemplate"
  ]);
  useEffect(() => {
    if (!rejectedChangesNotificationMailTemplate[locales[0]]) {
      dispatch(getRejectedChangesNotificationMailTemplate(locales[0]));
    }
  }, []);
  useEffect(() => {
    setTitle(t("title", { ns: "FA52-B-RejectedChangesNotificationMailTemplate" }));
  }, [t, setTitle]);
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  return (
    <>
      {modalIsVisible ? (
        <Modal
          visible={modalIsVisible}
          onCancel={() => {
            setModalIsVisible(false);
          }}
          footer={[
            <Button
              key="ok"
              className="btn btn_v2"
              onClick={() => {
                setModalIsVisible(false);
              }}
            >
              ОК
            </Button>
          ]}
        >
          <p>{modalMessage}</p>
        </Modal>
      ) : null}
      <Row>
        <Col sm={{ span: 24 }} xxl={{ span: 20 }} className={`regular_block`}>
          {isLoading && <Loader />}
          <div>
            <h5>{t("availableVariables")}</h5>
            <p>#FIRSTNAME - {t("FIRSTNAME", { ns: "FA5-ExporterIncomingRequestMailTemplate" })}</p>
            <p>#LASTNAME - {t("LASTNAME", { ns: "FA5-ExporterIncomingRequestMailTemplate" })}</p>
            <p>#LINK - {t("LINK", { ns: "FA52-B-RejectedChangesNotificationMailTemplate" })}</p>
            <p>#REASON - {t("REASON", { ns: "FA52-B-RejectedChangesNotificationMailTemplate" })}</p>
          </div>
          <Tabs
            defaultActiveKey={0}
            onChange={(key) => {
              tabsChange(
                key,
                rejectedChangesNotificationMailTemplate,
                dispatch,
                getRejectedChangesNotificationMailTemplate
              );
            }}
          >
            {locales.map((el, i) => (
              <TabPane tab={el} key={i}>
                <Col span={12}>
                  <p className="mb-12">
                    {t("mailSubject", { ns: "FA5-ExporterIncomingRequestMailTemplate" })}
                  </p>
                  <Form>
                    <Form.Item>
                      <Input
                        value={rejectedChangesNotificationMailTemplate[locales[i]]?.subject}
                        onChange={(e) => {
                          dispatch(
                            setMailTemplateSubject({
                              mailTemplate: REJECTED_CHANGES_NOTIFICATION_MAIL_TEMPLATE,
                              lang: el,
                              subject: e.target.value
                            })
                          );
                        }}
                      />
                    </Form.Item>
                  </Form>
                </Col>
                <Editor
                  inline_styles={true}
                  apiKey={TINY_MCE_API_KEY}
                  plugins={["code"]}
                  value={rejectedChangesNotificationMailTemplate[locales[i]]?.template}
                  init={{
                    relative_urls: false,
                    remove_script_host: false,
                    document_base_url: PRODUCTION_URL
                  }}
                  onEditorChange={(content) => {
                    dispatch(
                      setMailTemplate({
                        mailTemplateName: REJECTED_CHANGES_NOTIFICATION_MAIL_TEMPLATE,
                        mailTemplateContent: content,
                        lang: locales[i]
                      })
                    );
                  }}
                />
                <div>
                  <h5 className="mt-50 mb-24">{t("mailTemplate")}</h5>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: rejectedChangesNotificationMailTemplate[locales[i]]?.template
                        ?.replace("#FIRSTNAME", t("FIRSTNAMEex"))
                        ?.replace("#LASTNAME", t("LASTNAMEex"))
                        ?.replace(
                          "#LINK",
                          t("LINKex", { ns: "FA52-B-RejectedChangesNotificationMailTemplate" })
                        )
                        ?.replace(
                          "#REASON",
                          t("REASONex", { ns: "FA52-B-RejectedChangesNotificationMailTemplate" })
                        )
                    }}
                  ></div>
                </div>
                <Button
                  onClick={() => {
                    updateTemplate(
                      locales[i],
                      rejectedChangesNotificationMailTemplate,
                      setModalMessage,
                      setModalIsVisible,
                      mailTemplateAPI.updateRejectedChangesNotificationMailTemplate,
                      t,
                      dispatch
                    );
                  }}
                  className="btn btn_v2 ml-auto mt-24"
                >
                  {t("buttons.save")}
                </Button>
              </TabPane>
            ))}
          </Tabs>
        </Col>
      </Row>
    </>
  );
};
